import { render, staticRenderFns } from "./TerritoryZipRow.vue?vue&type=template&id=2cb3d2c3&scoped=true&"
import script from "./TerritoryZipRow.vue?vue&type=script&lang=js&"
export * from "./TerritoryZipRow.vue?vue&type=script&lang=js&"
import style0 from "./TerritoryZipRow.vue?vue&type=style&index=0&id=2cb3d2c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb3d2c3",
  null
  
)

export default component.exports